var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 7,
    viewBox: "0 0 12 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    fillOpacity: 0.6,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5327 2.02796C11.8243 1.73376 11.8222 1.25889 11.528 0.967309C11.2338 0.675726 10.7589 0.677844 10.4673 0.972041L8.72 2.73501C8.01086 3.4505 7.52282 3.94131 7.1093 4.27341C6.7076 4.596 6.44958 4.70668 6.2185 4.73613C6.07341 4.75462 5.92659 4.75462 5.7815 4.73613C5.55042 4.70668 5.2924 4.59601 4.89071 4.27341C4.47718 3.94131 3.98914 3.45051 3.28 2.73501L1.53269 0.972042C1.24111 0.677845 0.766238 0.675726 0.472041 0.96731C0.177844 1.25889 0.175726 1.73376 0.467309 2.02796L2.24609 3.82269C2.91604 4.49866 3.46359 5.05114 3.95146 5.44294C4.45879 5.85037 4.97373 6.14531 5.59184 6.22409C5.86287 6.25864 6.13714 6.25864 6.40816 6.22409C7.02628 6.14531 7.54122 5.85037 8.04854 5.44294C8.53641 5.05114 9.08396 4.49867 9.7539 3.82269L11.5327 2.02796Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseArrow);
export default __webpack_public_path__ + "static/media/closeArrow.94ceb24adfd09b04a973fdf904ae0cec.svg";
export { ForwardRef as ReactComponent };